import * as _ from "lodash";
import {UserEditForm} from '../../utils/validators';

export const SET_USER_EDIT_FORM = 'SET_USER_EDIT_FORM',
    USER_EDIT_FORM_CHANGE = 'USER_EDIT_FORM_CHANGE',
    SET_USER_FORM_ERROR = 'SET_USER_FORM_ERROR',
    RESET_EDIT_FORM = 'RESET_EDIT_FORM';

interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    validate: boolean
}

export interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            error: any,
            dirty?: boolean,
            errTypes?: any
        },
    }
}

const initialState: Form = {
    valid: false,
    data: {
        fullName: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        email: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        firstName: {
            required: false,
            added: false,
            value: null,
            error: null
        },
        lastName: {
            required: false,
            added: false,
            value: null,
            error: null
        },
        phone: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        businessName: {
            required: false,
            added: false,
            value: null,
            error: null
        },
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);

const UserEdit = (state = initialState, action: Action) => {
    switch (action.type) {
        case SET_USER_EDIT_FORM:
            return UserEditForm.Setup({...state.data}, action);
        case USER_EDIT_FORM_CHANGE:
            return UserEditForm.Validate({...state.data}, action);
        case SET_USER_FORM_ERROR:
            const newState = _.cloneDeep(state);
            newState.data.email.error = action.payload;
            return newState;
        case RESET_EDIT_FORM:
            return _.cloneDeep(baseState);
        default:
            return state;
    }
};

export default UserEdit;
